// extracted by mini-css-extract-plugin
var _1 = "devS1Ir1MOkc7l7vqgQA";
var _2 = "SqDFHoeYY_6DvP1C_n5_";
export { _1 as "heading", _2 as "wrapper" }
